<template>
    <div>
        <card-header title="Edit Outline Item" icon="fa-pencil"/>

        <card-body>
            <card-list>
                <subheader-list-item icon="fa-align-left" title="Basic Information"/>

                <container-list-item padded no-border>
                    <div class="columns">
                        <div class="column">
                            <b-field label="Title" label-position="inside">
                                <b-input v-model="item.title"></b-input>
                            </b-field>
                        </div>
                    </div>
                </container-list-item>
                <container-list-item padded no-border>
                    <div class="columns">
                        <div class="column">
                            <b-field label="Section Overview/Learning Objective" label-position="inside" message="Provide a 'Learning Objective' to display an 'Overview' for this section in the course outline.">
                                <b-input type="textarea" v-model="item.description"></b-input>
                            </b-field>
                        </div>
                    </div>
                </container-list-item>

            </card-list>

        </card-body>

        <card-footer class="pt-3 pb-3">
            <div class="columns">
                <div class="column has-text-right">
                    <b-button
                        type="is-primary"
                        size="is-small"
                        @click="submit"
                        :disabled="!item.title"
                    >
                        <i class="fas fa-check mr-2"></i>Save
                    </b-button>
                </div>
            </div>
        </card-footer>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardToolbar from "@/TIER/components/CardToolbar";
    import CardFooter from "@/TIER/components/CardFooter";
    import CardList from "@/TIER/components/CardList";
    import NavigationListItem from "@/TIER/components/NavigationListItem";
    import CardListItem from "@/TIER/components/CardListItem";
    import SubheaderListItem from "@/TIER/components/SubheaderListItem";
    import SeparatorListItem from "@/TIER/components/SeparatorListItem";

    import CourseForm from "@/cards/courses/CourseForm";

    import {client as http} from '../../http_client';
    import ContainerListItem from "../../TIER/components/ContainerListItem";
    import async from "async";

    export default {
        components: {ContainerListItem, SeparatorListItem, SubheaderListItem, CardListItem, CourseForm, NavigationListItem, CardList, CardFooter, CardToolbar, CardBody, CardHeader},
        props: ['card', 'props'],
        data() {
            return {
                item: {},
                course: {outline: []},
                confirmDelete: false,
                dirty: null,
                reqTimeToggle: false,
                reqScoreToggle: false
            };
        },
        methods: {
            load: function() {
                this.$emit('loading', true);
                async.series([
                    (cb) => {
                        http.get('courses/new/' + this.props.courseId, {force: true}).then(response => { // TODO: temporary endpoint
                            if (!response.data.outline) response.data.outline = []; //TODO temp
                            this.course = response.data;
                            cb();
                        }).catch(err => {
                            cb(err);
                        });
                    },
                    (cb) => {
                        http.get('course-outline/' + this.props.outlineId, {force: true}).then(response => {
                            this.item = response.data;
                            cb();
                        }).catch(err => {
                            cb(err);
                        });
                    }
                ], err => {
                    this.$emit('loading', false);
                });
            },
            submit: function() {
                this.$emit('loading', true);
                http.put('course-outline/' + this.props.outlineId, this.item, {force: true}).then(response => {
                    // this.$reloadCard('edit-section', {courseId: this.props.courseId});
                    this.$reloadCard('course-outline', {courseId: this.props.courseId});
                    this.$saveAlert(false);
                    this.dirty = null;
                    this.$closeCard(this.card);
                }).catch(err => {

                });
            }
        },
        watch: {
            'props.outlineId': function() {
                this.dirty = null;
                this.load();
            },
            'item': {
                deep: true,
                handler: function() {
                    this.dirty = (this.dirty !== null);
                    if (!this.$TIER.saveAlert.active && this.dirty)
                        this.$saveAlert(true, 'Are you done editing this item? Unsaved changes will be lost.');
                }
            }
        },
        mounted() {
            this.load();
        }
    };
</script>
